export const SET_OPTIONS = 'SET_OPTIONS';
export const SET_DEFAULT_CUSTOMIZABLE = 'SET_DEFAULT_CUSTOMIZABLE';
export const RESTORE_CUSTOMIZABLE = 'RESTORE_CUSTOMIZABLE';
export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export const SET_CONFIGURATOR = 'SET_CONFIGURATOR';
export const SELECT_OPTION_ITEM = 'SELECT_OPTION_ITEM';
export const SELECT_OPTION_ITEM_NESTED = 'SELECT_OPTION_ITEM_NESTED';